import callAPiBase from './base';

const officeHoursApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/api/officehours`,
      method: 'GET',
      useToken: true,
      params,
    }),
  get: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/officehour?ID=${ID}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/officehour',
      method: 'POST',
      useToken: true,
      data,
    }),
  update: ({ ID, data }: { ID: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/officehour?ID=${ID}`,
      method: 'PUT',
      useToken: true,
      data,
    }),
  delete: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/officehour?ID=${ID}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { officeHoursApi };
export default officeHoursApi;
